import React from "react";
import DialogConfirmCancel from "../../../../../dialog/DialogConfirm";
import LogCardMin from "./LogCardMin";
import LogCardMax from "./LogCardMax";

const DialogLogs = ({
  show,
  logId,
  onClose,
  logs = [],
  lcs = [],
  currentCurriculum,
}) => {
  const [selected, setSelected] = React.useState(logId);

  const log = logs.find((log) => log._id === selected)
  const lc = lcs.find((lc) => String(lc._id) === String(log?.lcId));

  return (
    <DialogConfirmCancel
      id={`dialog-logs`}
      open={show}
      onCancel={onClose}
      textCancel="Close"
      onConfirm={undefined}
      title={'Logs'}
      onCloseHeader={true}
      maxWidth="md"
    >
      <div className="grid grid-cols-4 gap-4">
        <div className="h-screen-1/2 overflow-auto flex flex-col gap-2 px-2">
          {logs.map((log, i) => {
              const lc = lcs.find((lc) => String(lc._id) === String(log.lcId));
              return (
                <LogCardMin
                  className={[
                    "cursor-pointer",
                    log._id === selected ? "bg-selected" : "bg-clickeabled ",
                  ].join(" ")}
                  id={`log-${log._id}-${i}-${log.lcId}`}
                  key={`log-${log._id}-${i}-${log.lcId}`}
                  log={log}
                  lc={lc}
                  currentCurriculum={currentCurriculum}
                  showChange={false}
                  onClick={() => setSelected(log._id)}
                />
              );
            })}
        </div>
        <div className="h-screen-1/2 col-span-3 overflow-auto">
          {log && lc &&
            <LogCardMax 
              id={`log-${log.lcId}-${selected}`}
              log={log}
              lc={lc}
              currentCurriculum={currentCurriculum}
            />
          }
        </div>
      </div>
    </DialogConfirmCancel>
  );
};

export default DialogLogs;
